import { api } from "./client"

export type PipelineStage = {
  id: string
  organization_id: string
  job_id: string | null
  name: string
  position: number
  color: string
  is_final: boolean
  is_rejected: boolean
  created_at: string
}

export type PipelineApplication = {
  id: string
  current_stage_id: string | null
  status: string
  applied_at: string
  candidate: { id: string; full_name: string; email: string } | null
  job: { id: string; title: string } | null
  analysis: { match_score: number | null } | null
}

export const pipelineApi = {
  stages: (jobId?: string) =>
    api<{ data: PipelineStage[] }>(
      `/pipeline/stages${jobId ? `?job_id=${jobId}` : ""}`,
    ),
  applications: (jobId?: string) =>
    api<{ data: PipelineApplication[] }>(
      `/pipeline/applications${jobId ? `?job_id=${jobId}` : ""}`,
    ),
  move: (applicationId: string, newStageId: string, note?: string) =>
    api<{ ok: boolean }>("/pipeline/move", {
      method: "POST",
      body: { application_id: applicationId, new_stage_id: newStageId, note },
    }),
}
